<template>
  <NuxtLink :class="['block', isDarkTheme ? 'text-white' : 'text-gray9']" :to="`/experiences/${experience.slug}/`" @click="handleClick">
    <div class="group font-Spectral">
      <div :class="['block w-full', isVertical ? 'md:flex md:flex-row' : '']">
        <div :class="['mb-2 max-w-full overflow-hidden', isVertical ? 'min-w-[280px] md:w-64' : '']">
          <MoleculesWabunkaExperienceCarousel :display-multiple-images="props.displayMultipleImages" :images="displayImages" :is-vertical="orientation === 'vertical'" />
        </div>
        <div :class="[isVertical ? 'md:ml-4 md:flex md:flex-col md:justify-center' : '']">
          <ExperienceCardContent :experience="experience" :theme="props.theme" />
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { WabunkaExperienceViewModel } from '@/models/wabunka/wabunkaExperience';
import { ExperienceCardContent } from '@/wabunka-src/features/Experience';

interface Props {
  experience: WabunkaExperienceViewModel;
  // 表示する画像の枚数
  displayNumberOfImages?: number;
  // 複数枚の画像を表示するかどうか
  // パフォーマンス向上のために利用
  displayMultipleImages: boolean;
  // テーマを指定
  theme: 'light' | 'dark';
  // 縦並びか横並びかを指定
  orientation: 'vertical' | 'horizontal';
  // クリックイベントハンドラ
  onExperienceClick?: (experienceSlug: string) => void;
}

/**
 * 🚨 体験シリーズ機能を導入する場合、忘れずにセクションviewイベントを新しいコンポーネントに付与すること（その時にはシリーズIDという呼び名かも）
 *  sendGAWabunkaSectionViewEvent(props.sectionId, route.name);
 *  sendGAWabunkaSectionExperienceViewEvent(props.sectionId, props.enExperience.id, route.name);
 */

const props = withDefaults(defineProps<Props>(), {
  displayNumberOfImages: undefined,
  theme: 'light',
  orientation: 'vertical',
});

const handleClick = () => {
  if (props.onExperienceClick) {
    props.onExperienceClick(props.experience.slug);
  }
};
const displayImages = computed(() => {
  if (!props.displayMultipleImages) {
    return props.experience.images;
  }

  // displayNumberOfImagesが未指定の場合は全ての画像を表示
  if (props.displayNumberOfImages === undefined) {
    return props.experience.images;
  }

  // displayNumberOfImagesが指定されている場合は、指定された枚数分の画像のみを表示
  return props.experience.images?.filter((image) => {
    if (!image.sequenceId || !props.displayNumberOfImages) {
      return false;
    }
    return image.sequenceId <= props.displayNumberOfImages;
  });
});

const isDarkTheme = computed(() => props.theme === 'dark');
const isVertical = computed(() => props.orientation === 'vertical');
</script>
